import { render, staticRenderFns } from "./logoffCode.vue?vue&type=template&id=4aac4a91&scoped=true"
import script from "./logoffCode.vue?vue&type=script&lang=js"
export * from "./logoffCode.vue?vue&type=script&lang=js"
import style0 from "./logoffCode.vue?vue&type=style&index=0&id=4aac4a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aac4a91",
  null
  
)

export default component.exports